import { render, staticRenderFns } from "./QrReader.vue?vue&type=template&id=04633612&lang=pug&"
import script from "./QrReader.vue?vue&type=script&lang=js&"
export * from "./QrReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports